<section class="agpr-newBriefing">
    <h2 class="agpr-newBriefing-heading">
        {{ 'Briefings.newBriefing.heading' | localize }}
    </h2>
    <agpr-tabs
        [id]="'agpr_newBriefing_tabs'"
        class="agpr-newBriefing-tabs"
        [selectedTabIndex]="selectedTabIndex"
        (selectedTabIndexChange)="changeTabs($event)"
    >
        <agpr-tab
            [id]="'agpr_newBriefing_quickTemplates_tab'"
            icon="fa-kit-duotone fa-agpr-template"
            heading="Briefings.newBriefing.tab.quickTemplates"
            class="agpr-newBriefing-tab"
        >
            <div class="agpr-paddedContent">
                <h3 class="agpr-newBriefing-subHeading">
                    {{ 'Briefings.createDialog.chooseTemplate' | localize }}
                </h3>
                <div class="agpr-newBriefing-quickTemplates-templateSelection">
                    <button
                        class="agpr-newBriefing-quickTemplates-templateSelectionOption agpr-contextMenu-parent"
                        [ngClass]="{'agpr-newBriefing-quickTemplates-templateSelectionOption--focused': selectedQuickTemplateOption === briefingTemplateOptions.one}"
                        (click)="onQuickTemplateSelect(briefingTemplateOptions.one)"
                        [attr.aria-label]="'Monitor.userPreferences.corporateTemplateLabel' | localize"
                        agprTooltip="Monitor.userPreferences.corporateTemplateLabel"
                        tooltipPosition="bottom"
                    >
                        <img
                            class="agpr-newBriefing-quickTemplates-templateSelectionThumbnail"
                            [src]="appBaseHref + 'assets/images/BriefingPreviewAThumbnail.jpg'"
                            [alt]="'Monitor.userPreferences.corporateTemplateLabel' | localize"
                        />
                        <agpr-button
                            class="agpr-contextMenu top right"
                            [style]="buttonTypesEnum.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-magnifying-glass-plus'"
                            (click)="preview(appBaseHref + 'assets/images/BriefingPreviewA.jpg')"
                            [ariaLabel]="'Briefings.createDialog.preview' | localize"
                        ></agpr-button>
                    </button>
                    <button
                        class="agpr-newBriefing-quickTemplates-templateSelectionOption agpr-contextMenu-parent"
                        [ngClass]="{'agpr-newBriefing-quickTemplates-templateSelectionOption--focused': selectedQuickTemplateOption === briefingTemplateOptions.two}"
                        (click)="onQuickTemplateSelect(briefingTemplateOptions.two)"
                        [attr.aria-label]="'Monitor.userPreferences.vividTemplateLabel' | localize"
                        agprTooltip="Monitor.userPreferences.vividTemplateLabel"
                        tooltipPosition="bottom"
                    >
                        <img
                            class="agpr-newBriefing-quickTemplates-templateSelectionThumbnail"
                            [src]="appBaseHref + 'assets/images/BriefingPreviewBThumbnail.jpg'"
                            [alt]="'Monitor.userPreferences.vividTemplateLabel' | localize"
                        />
                        <agpr-button
                            class="agpr-contextMenu top right"
                            [style]="buttonTypesEnum.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-magnifying-glass-plus'"
                            (click)="preview(appBaseHref + 'assets/images/BriefingPreviewB.jpg')"
                            [ariaLabel]="'Briefings.createDialog.preview' | localize"
                        ></agpr-button>
                    </button>
                    <button
                        class="agpr-newBriefing-quickTemplates-templateSelectionOption agpr-contextMenu-parent"
                        [ngClass]="{'agpr-newBriefing-quickTemplates-templateSelectionOption--focused': selectedQuickTemplateOption === briefingTemplateOptions.three}"
                        (click)="onQuickTemplateSelect(briefingTemplateOptions.three)"
                        [attr.aria-label]="'Monitor.userPreferences.minimalistTemplateLabel' | localize"
                        agprTooltip="Monitor.userPreferences.minimalistTemplateLabel"
                        tooltipPosition="bottom"
                    >
                        <img
                            class="agpr-newBriefing-quickTemplates-templateSelectionThumbnail"
                            [src]="appBaseHref + 'assets/images/BriefingPreviewCThumbnail.jpg'"
                            [alt]="'Monitor.userPreferences.minimalistTemplateLabel' | localize"
                        />
                        <agpr-button
                            class="agpr-contextMenu top right"
                            [style]="buttonTypesEnum.contextMenu"
                            [icon]="'fa-regular fa-duotone fa-magnifying-glass-plus'"
                            (click)="preview(appBaseHref + 'assets/images/BriefingPreviewC.jpg')"
                            [ariaLabel]="'Briefings.createDialog.preview' | localize"
                        ></agpr-button>
                    </button>
                </div>
                <h3 class="agpr-newBriefing-subHeading">
                    {{ 'Briefings.createDialog.quickCreateHeader' | localize }}
                </h3>
                <div class="agpr-newBriefing-quickTemplates-wrapper">
                    <agpr-checkbox
                        [id]="'agpr_newBriefing_quickTemplates_useQuickCreate'"
                        label="Briefings.createDialog.quickDialogLabel"
                        [(ngModel)]="useQuickBriefing"
                        [binary]="true"
                    ></agpr-checkbox>
                    @if (useQuickBriefing) {
                        <div
                            #quickCreateForm
                            [id]="'agpr_newBriefing_quickTemplates_form'"
                            class="agpr-newBriefing-quickTemplates-form"
                        >
                            <div class="agpr-newBriefing-quickTemplates-row">
                                <div class="agpr-newBriefing-quickTemplates-column">
                                    <div class="agpr-newBriefing-quickTemplates-item">
                                        <agpr-monitoring-source-picker-with-facet-field
                                            [id]="'agpr_newBriefing_quickTemplates_sourcePicker'"
                                            class="agpr-newBriefing-quickTemplates-sourcePicker"
                                            [field]="sourceField"
                                            [value]="dataSource"
                                            (changes)="sourceSelected($event)"
                                            [showHiddenOption]="true"
                                        ></agpr-monitoring-source-picker-with-facet-field>
                                    </div>
                                    @if (dataSource?.type === topicEnum && dataSource.id) {
                                        <agpr-message
                                            class="agpr-newBriefing-quickTemplates-message"
                                            [severity]="messageSeverityEnum.info"
                                        >
                                            {{ 'Briefing.input.topicDataSourceMessage' | localize }}
                                        </agpr-message>
                                    }
                                </div>
                                <div class="agpr-newBriefing-quickTemplates-column">
                                    @if (isUnsavedDataSource) {
                                        <div class="agpr-newBriefing-quickTemplates-organizeBy agpr-newBriefing-quickTemplates-item">
                                            <agpr-dropdown
                                                label="Briefings.input.organizeSectionsBy"
                                                [options]="organizeOptions"
                                                [(ngModel)]="selectedOrganizeOption"
                                                (ngModelChange)="onOrganizeByChanged($event.value)"
                                            ></agpr-dropdown>
                                        </div>
                                        <div class="agpr-newBriefing-quickTemplates-sortBy agpr-newBriefing-quickTemplates-item">
                                            <agpr-dropdown
                                                [options]="sortByOptions"
                                                [(ngModel)]="selectedSortByOption"
                                                (ngModelChange)="onSortByChanged($event.value)"
                                                label="Briefing.input.sortMentionsBy"
                                            ></agpr-dropdown>
                                        </div>
                                        <div class="agpr-newBriefing-quickTemplates-maxNumberOfMentions agpr-newBriefing-quickTemplates-item">
                                            <agpr-number-field
                                                [field]="numberFieldModel"
                                                [value]="maxNumberOfMentions"
                                                (changes)="onMaxNumberOfMentionsChanged($event)"
                                            ></agpr-number-field>
                                            @if (showDataSourceError && showMaxNumberOfMentionsError) {
                                                <agpr-form-message [id]="'maxMentions_error'">
                                                    {{ 'Briefings.dynamicMentionsList.form.numberOfMentionsErrorMessage' | localize }}
                                                </agpr-form-message>
                                            }
                                        </div>
                                    }
                                    @if (dataSource?.type === folderEnum || dataSource?.type === tagEnum || dataSource?.type === tagGroupEnum || dataSource?.type === sourceGroupEnum || dataSource?.type === aiAgentEnum) {
                                        <div class="agpr-newBriefing-quickTemplates-organizeBy agpr-newBriefing-quickTemplates-item">
                                            <agpr-dropdown
                                                [options]="organizeOptions"
                                                [(ngModel)]="selectedOrganizeOption"
                                                (ngModelChange)="onOrganizeByChanged($event.value)"
                                                label="Briefings.input.organizeSectionsBy"
                                            ></agpr-dropdown>
                                            @if (organizeBy === organizeByEnum.TAGS) {
                                                <div
                                                    class="agpr-newBriefing-quickTemplates-tagsPicker"
                                                >
                                                    <agpr-tags-picker
                                                        [showHeader]="false"
                                                        [placeholder]="'Briefing.input.organizeByTagsPlaceholder'"
                                                        [(ngModel)]="tagIds"
                                                        (ngModelChange)="onTagIdsChanged($event)"
                                                    ></agpr-tags-picker>
                                                    @if (showDataSourceError && tagIds.length === 0) {
                                                        <agpr-form-message>
                                                            {{ 'Briefing.input.tags.error.required' | localize }}
                                                        </agpr-form-message>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div class="agpr-newBriefing-quickTemplates-sortBy agpr-newBriefing-quickTemplates-item">
                                            <agpr-dropdown
                                                label="Briefing.input.sortMentionsBy"
                                                [options]="sortByOptions"
                                                [(ngModel)]="selectedSortByOption"
                                                (ngModelChange)="onSortByChanged($event.value)"
                                            ></agpr-dropdown>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </agpr-tab>
        <agpr-tab
            [id]="'newBriefing_savedTemplates_tab'"
            class="agpr-newBriefing-tab"
            icon="fa-regular fa-duotone fa-floppy-disk"
            heading="Briefings.createDialog.savedTemplate"
        >
            <div class="agpr-paddedContent">
                <h3 class="agpr-newBriefing-subHeading">
                    {{ 'Briefings.createDialog.chooseTemplate' | localize }}
                </h3>
                <agpr-list-filter-select
                    [id]="'agpr_newBriefing_saveTemplates_filterSelectList'"
                    [list]="templateListItems"
                    [vsMinBufferPx]="560"
                    [vsMaxBufferPx]="1050"
                    listAriaLabel="Briefings.newBriefing.savedTemplates.listArialLabel"
                    placeholder="Briefings.newBriefing.savedTemplates.helperText"
                    textInputAriaLabel="Briefings.newBriefing.savedTemplates.helperText"
                    [showActionButton]="true"
                    actionButtonTooltip="Briefings.newBriefing.savedTemplates.manageTemplates"
                    (actionButtonClicked)="openManageTemplateDialog()"
                    (itemSelected)="onTemplateSelect($event)"
                ></agpr-list-filter-select>
            </div>
        </agpr-tab>
        <agpr-tab
            [id]="'newBriefing_pastBriefings_tab'"
            class="agpr-newBriefing-tab"
            icon="fa-solid fa-duotone fa-clock-rotate-left"
            heading="Briefings.newBriefing.tab.pastBriefings"
        >
            <div class="agpr-paddedContent">
                <h3 class="agpr-newBriefing-subHeading">
                    {{ 'Briefings.newBriefing.subHeading.pastBriefings' | localize }}
                </h3>
                <agpr-list-filter-select
                    [id]="'agpr_newBriefing_pastBriefings_filterSelectList'"
                    [list]="briefingListItems"
                    [vsMinBufferPx]="560"
                    [vsMaxBufferPx]="1050"
                    listAriaLabel="Briefings.newBriefing.pastBriefings.listArialLabel"
                    placeholder="Briefings.createDialog.pastBriefingSearchPlaceholder"
                    textInputAriaLabel="Briefings.createDialog.pastBriefingSearchPlaceholder"
                    (itemSelected)="onBriefingSelect($event)"
                ></agpr-list-filter-select>
            </div>
        </agpr-tab>
    </agpr-tabs>
    <agpr-action-bar class="agpr-newBriefing-actionBar">
        <ng-template #right>
            <agpr-button
                (click)="cancel()"
                [style]="buttonTypesEnum.secondary"
                label="Core.button.cancel"
            ></agpr-button>
            <agpr-button
                [style]="buttonTypesEnum.primary"
                label="Briefings.createDialog.createNewBriefing"
                [loading]="loadingTemplates"
                (click)="createBriefing()"
                [disabled]="selectedTabIndex === newBriefingTabsEnum.pastBriefings && selectedBriefing === null ||
                            selectedTabIndex === newBriefingTabsEnum.savedTemplates && selectedTemplate === null ||
                            loadingTemplates"
                [tooltip]="selectedTabIndex === newBriefingTabsEnum.pastBriefings && selectedBriefing === null ||
                            selectedTabIndex === newBriefingTabsEnum.savedTemplates && selectedTemplate === null ?
                            'Monitoring.amplify.createBriefing.disabledTooltip' : null"
            ></agpr-button>
        </ng-template>
    </agpr-action-bar>
</section>